import React from 'react';
import { motion } from 'framer-motion';
import { MicIcon, BrainCircuitIcon, TrendingUpIcon, NetworkIcon, GamepadIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function UseCasesSlide() {
  return <SlideLayout data-id="element-468">
      <motion.div variants={itemVariants} className="mb-12 text-center" data-id="element-469">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-470">
          Built for Production Workloads
        </h2>
        <p className="text-xl text-brand-text-dim" data-id="element-471">
          Latency-Sensitive & Cost-Sensitive
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-6 gap-6 max-w-5xl mx-auto" data-id="element-472">
        {/* Top Row - 3 Cards */}
        <motion.div variants={itemVariants} className="md:col-span-2 bg-brand-bg-card border border-brand-border hover:border-brand-teal/50 transition-colors rounded-2xl p-6 relative overflow-hidden group" data-id="element-473">
          <div className="absolute top-0 right-0 w-24 h-24 bg-brand-teal/5 blur-2xl rounded-full group-hover:bg-brand-teal/10 transition-colors" data-id="element-474" />
          <MicIcon className="w-8 h-8 text-brand-teal mb-4 relative z-10" data-id="element-475" />
          <h3 className="text-xl font-bold text-brand-text mb-2 relative z-10" data-id="element-476">
            Real-Time Voice & Chat
          </h3>
          <p className="text-sm text-brand-text-dim relative z-10" data-id="element-477">
            Sub-100ms time-to-first-token for natural conversational flow.
            Deterministic latency eliminates spikes that break interactions.
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="md:col-span-2 bg-brand-bg-card border border-brand-border hover:border-brand-teal/50 transition-colors rounded-2xl p-6 relative overflow-hidden group" data-id="element-478">
          <div className="absolute top-0 right-0 w-24 h-24 bg-brand-teal/5 blur-2xl rounded-full group-hover:bg-brand-teal/10 transition-colors" data-id="element-479" />
          <BrainCircuitIcon className="w-8 h-8 text-brand-teal mb-4 relative z-10" data-id="element-480" />
          <h3 className="text-xl font-bold text-brand-text mb-2 relative z-10" data-id="element-481">
            Autonomous AI Agents
          </h3>
          <p className="text-sm text-brand-text-dim relative z-10" data-id="element-482">
            High call volume, tight cost budgets. Agents making thousands of
            calls need the lowest $/M tokens without sacrificing speed.
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="md:col-span-2 bg-brand-bg-card border border-brand-border hover:border-brand-teal/50 transition-colors rounded-2xl p-6 relative overflow-hidden group" data-id="element-483">
          <div className="absolute top-0 right-0 w-24 h-24 bg-brand-teal/5 blur-2xl rounded-full group-hover:bg-brand-teal/10 transition-colors" data-id="element-484" />
          <TrendingUpIcon className="w-8 h-8 text-brand-teal mb-4 relative z-10" data-id="element-485" />
          <h3 className="text-xl font-bold text-brand-text mb-2 relative z-10" data-id="element-486">
            Financial Analytics
          </h3>
          <p className="text-sm text-brand-text-dim relative z-10" data-id="element-487">
            Speed and determinism matter. Low-jitter inference for real-time
            trend analysis where milliseconds translate to dollars.
          </p>
        </motion.div>

        {/* Bottom Row - 2 Cards Centered */}
        <motion.div variants={itemVariants} className="md:col-start-2 md:col-span-2 bg-brand-bg-card border border-brand-border hover:border-brand-teal/50 transition-colors rounded-2xl p-6 relative overflow-hidden group" data-id="element-488">
          <div className="absolute top-0 right-0 w-24 h-24 bg-brand-teal/5 blur-2xl rounded-full group-hover:bg-brand-teal/10 transition-colors" data-id="element-489" />
          <NetworkIcon className="w-8 h-8 text-brand-teal mb-4 relative z-10" data-id="element-490" />
          <h3 className="text-xl font-bold text-brand-text mb-2 relative z-10" data-id="element-491">
            Multi-Agent Orchestration
          </h3>
          <p className="text-sm text-brand-text-dim relative z-10" data-id="element-492">
            Frameworks like AutoGen routing to cheaper open-source models.
            OpenFPGA makes them fast enough for tight loops.
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="md:col-span-2 bg-brand-bg-card border border-brand-border hover:border-brand-teal/50 transition-colors rounded-2xl p-6 relative overflow-hidden group" data-id="element-493">
          <div className="absolute top-0 right-0 w-24 h-24 bg-brand-teal/5 blur-2xl rounded-full group-hover:bg-brand-teal/10 transition-colors" data-id="element-494" />
          <GamepadIcon className="w-8 h-8 text-brand-teal mb-4 relative z-10" data-id="element-495" />
          <h3 className="text-xl font-bold text-brand-text mb-2 relative z-10" data-id="element-496">
            Game AI & NPCs
          </h3>
          <p className="text-sm text-brand-text-dim relative z-10" data-id="element-497">
            Localized inference brains for complex NPC behavior. Low-latency,
            low-cost inference that runs alongside game logic.
          </p>
        </motion.div>
      </div>
    </SlideLayout>;
}